import { Skeleton } from 'antd';
import './HomeUserProfileSkeleton.scss';

const HomeUserProfileSkeleton = ({ workspacePage = false }) => {
  return (
    <div
      className={`home-profile d-flex align-items-stretch ${
        workspacePage ? 'px-4 w-100 b-radius-8 bg-white' : 'w-100 px-4'
      }`}
    >
      <div
        className={`d-flex flex-row ${
          workspacePage ? 'px-2 w-100 workspace-profile-content' : 'gap-2 w-100'
        }`}
      >
        <div className="d-flex align-items-center">
          <Skeleton.Avatar
            active
            className={
              workspacePage
                ? 'size-profile-img skeleton-avatar'
                : 'home-profile-img skeleton-avatar'
            }
          />
        </div>
        <div
          className={`d-flex w-100 ${
            workspacePage
              ? 'flex-row  align-items-center justify-content-between'
              : 'justify-content-between flex-column w-100'
          }`}
          style={{ minHeight: '100%' }}
        >
          <span
            className={`font-weight-700  text-title ${
              workspacePage ? 'position-profile-name' : ''
            }`}
          >
            <Skeleton.Input active className="skeleton-user-name" />
          </span>
          <div
            className={`d-flex gap-1 mt-auto ${
              workspacePage
                ? 'button-create-workspace w-50 align-items-center justify-self-end'
                : 'w-100 flex-column'
            }`}
          >
            <div className={`${workspacePage ? 'position-progress-bar w-100' : 'w-100'}`}>
              <span className="font-weight-600 text-xs">
                <Skeleton.Input active className="skeleton-profile-percentage" />
              </span>
              <div className="skeleton-progress-container">
                <Skeleton.Button active className="skeleton-progress-bar" block />
              </div>
            </div>
            <div
              className={`d-flex ${
                workspacePage ? 'w-50' : 'flex-column flex-md-row gap-1 home-profile-content w-100'
              } justify-content-end`}
            >
              <Skeleton.Button active className={`skeleton-profile-button ${workspacePage ? '' : 'home-profile-button'}`} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeUserProfileSkeleton;
